module.exports = "<ubg-select-entity placeholder=\"Projekt auswählen\" [entities]=\"projectOptions\" [(ngModel)]=\"activeProjectPath\"></ubg-select-entity>"